import { MockTest } from 'src/app/utils/mock-test-analitico';
import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Pedidos } from 'src/app/models/pedidos.model';
import * as jwt_decode from 'jwt-decode';
import { UserAuthIamService } from 'src/app/features/proof-of-life/services/user-auth-iam/user-auth-iam.service';
import User from 'src/app/features/proof-of-life/services/user-auth/User';

@Injectable({
  providedIn: 'root'
})
export class MSolicitarRelAnaliticoService {

  documentoCliente: string;
  emailCliente: string;
  produtoSelecionado: string = "LGPD_ANALITICO";
  tipoDocumento: Number = 2;
  acaoCliente: string = "Relatorio Analitico LGPD";
  nomeCliente: string;
  meioacesso: number;
  origemDocumento: number;

  public listaServicoFalha: Array<string>;
  public userData = new User({});
  public loadingUser: boolean = false;
  public error: boolean = false;
  public loginError: boolean = false;
  public firstLetterName: string;
  public profileImage: any;
  public bUsuarioLogado: Boolean = false;
  decoded: any;

  constructor(
    public http: HttpClient,
    private readonly iamService: UserAuthIamService
  ) {
    this.bUsuarioLogado = this.verificarUsuarioLogado();
  }

  public verificarUsuarioLogado(): Boolean {
    let bretorno: Boolean = false;

    if (!(sessionStorage.getItem('accessTokenJWT') === undefined || sessionStorage.getItem('accessTokenJWT') == null)) {
      this.decoded = jwt_decode(sessionStorage.getItem('accessTokenJWT'));

      this.iamService.accountData().subscribe(
        data => {
          this.userData = data;
          this.loadingUser = false;
          this.firstLetterName = this.userData.fullName.charAt(0);
          this.profileImage = this.userData.picture;
          this.documentoCliente = this.userData.document;
          this.emailCliente = this.userData.email;
          this.nomeCliente = this.userData.fullName;
          this.origemDocumento = 22;
          bretorno = true;
          if (this.decoded.authorities.includes("ROLE_PERSON_VALIDATED")) {
            this.meioacesso = 36;
          } else if (this.decoded.authorities.includes("ROLE_AUTH-STRONG")) {
            this.meioacesso = 33;
          } else {
            bretorno = false;
          }
        },
        () => {
          this.loadingUser = false;
          this.error = true;
          this.loginError = true;
          console.log('UserData error');
        }
      );
    }
    return bretorno;
  }

  public createPedido(bodyPedido: Pedidos): Observable<any> {
    bodyPedido.clientEmail = this.emailCliente;
    bodyPedido.clientName = this.nomeCliente;
    bodyPedido.origin = this.origemDocumento;
    bodyPedido.middle = this.meioacesso;

    if (environment.name === 'local') {
      return this.http.post(environment.urlAnalitico + '/lgpd/analitico/pedido/v1/pedidos', JSON.stringify(bodyPedido));
    }
    return this.http.post(environment.urlAnalitico + '/lgpd/analitico/v1/pedidos', JSON.stringify(bodyPedido));
  }

  public retrieveFinalidades(): Observable<any> {

      if (environment.name === 'local') {
      return of(MockTest.criarMockListaFinalidadeRequest());
    }
    return this.http.get(environment.urlAnalitico + '/lgpd/analitico/v1/purposes');
  }

  public retrievePedido(): Observable<any> {
    if (environment.name === 'local') {
      return this.http.get(environment.urlAnalitico + '/lgpd/analitico/pedido/v1/pedidos');
    }
    return this.http.get(environment.urlAnalitico + '/lgpd/analitico/v1/pedidos');
  }

  public retrieveProtocolo(): Observable<any> {
    const bodyProtocolo = {
      "documentoCliente": this.documentoCliente,
      "email": this.emailCliente,
      "produto": this.produtoSelecionado,
      "tipoDocumento": this.tipoDocumento,
      "acaoCliente": this.acaoCliente
    };
    return this.http.post(`${environment.urlProtocolo}v2/protocolos`, bodyProtocolo
    );
  }
}
